var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"4","height":"17","fill":"none"}},[_c('circle',{attrs:{"cx":"1.7","cy":"1.7","r":"1.7","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"1.7","cy":"8.5","r":"1.7","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"1.7","cy":"15.3","r":"1.7","fill":"currentColor"}})])
}
var staticRenderFns = []

export default { render: render }